import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { createPatientTransferLogger, } from '../../../../account/sidebar/patient-transfer/logger';
export default class PatientTransferStartedTrack extends AbstractTrack {
    /* @ngInject */
    constructor($injector) {
        super($injector);
        this.$injector = $injector;
        this.eventNameSegment = 'Patient Transfer Started';
        this.logger = createPatientTransferLogger(this.stateWatcher);
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.PATIENT_TRANSFER.STARTED, ($e, context) => {
            this.logger?.info('Patient transfer started', {
                ...context,
                event_span: 'patient_transfer_initiated',
            });
            this.trackSegment(context, true);
        });
    }
}
